import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const Forbidden: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh' 
    }}>
      <Result
        status="403"
        title="403"
        subTitle="Désolé, vous n'avez pas accès à cette page."
        extra={
          <Button type="primary" onClick={() => navigate('/')}>
            Retour à l'accueil
          </Button>
        }
      />
    </div>
  );
};

export default Forbidden;